/* eslint-disable no-nested-ternary */
import Modal from "components/atoms/modal";
// import Button from "components/atoms/buttons/Button";
import { CheckBadgeIcon, ExclamationCircleIcon, XMarkIcon } from "@heroicons/react/24/solid";
// import { useRouter } from "components/hooks";
// import { ROUTES } from "../../../constants";
import SignInForm from "pages/signin/SignInForm";
import { useEffect, useState } from "react";

type Props = {
  isUserNew: boolean;
  isOpen: boolean;
  onClose: () => void;
  submissionStatus: string;
  errorMessage?: string;
  onLoginAfterSubmit?: () => void;
};

function ClaimMagnetModal({ isUserNew, isOpen, submissionStatus, onClose, errorMessage, onLoginAfterSubmit }: Props) {
  const [formType, setFormType] = useState<0 | 1 | 2 | 3>(1); // 0- signin, 1- signup, 2- reset password, 3- Otp Sent

  useEffect(() => {
    if (isUserNew === true || isUserNew === undefined) setFormType(1);
    else setFormType(0);
  }, [isUserNew, isOpen]);

  // const router = useRouter();

  // const handleGoToSignIn = () => {
  //   router.go(ROUTES.SIGNIN);
  // };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="relative max-w-[600px] rounded-2xl bg-primary px-7 pb-10 pt-12">
        <button
          type="button"
          className="absolute right-0  top-0 rounded-md p-4 text-white hover:text-opacity-70"
          onClick={onClose}
        >
          <XMarkIcon className="h-7 w-7" aria-hidden="true" />
        </button>
        <div className=" text-center text-white">
          {submissionStatus === "successfull" ? (
            <>
              <div className="text-lime-500">
                <CheckBadgeIcon className="mx-auto h-32 " />
              </div>
              <div>
                {isUserNew ? (
                  <>
                    <h3 className="text-lg font-bold ">Thank you</h3>
                    <p className="text-xs font-light">
                      Create a login now to access the program. We’ve sent you a confirmation email of your enrollment,
                      so be sure to check your spam!
                    </p>
                  </>
                ) : (
                  <>
                    <h3 className="text-lg font-bold ">Thank you</h3>
                    <p className="text-xs font-light">Please check your email for confirmation.</p>
                  </>
                )}
              </div>
            </>
          ) : submissionStatus === "failed" ? (
            <>
              <div className="text-red-500">
                <ExclamationCircleIcon className="mx-auto h-32 " />
              </div>
              <h5 className="text-lg font-bold">Your request could not be submitted.</h5>

              {errorMessage && <p className="mx-auto max-w-sm">{errorMessage}</p>}
            </>
          ) : null}
        </div>
        {submissionStatus !== "not-initiated" && <hr className="mb-4 mt-5 opacity-20" />}
        {/* <div className="flex justify-center space-x-4"> */}
        {/* {submissionStatus === "failed" && (
            <Button
              text="Dismiss"
              onClick={onClose}
              additionalClasses="xl:text-xxs px-3 py-1 xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
              variant="whiteOutline"
            />
          )}
          {submissionStatus === "successfull" && (
            <Button
              text={isUserNew ? "CREATE LOGIN" : "Check out on my Fridge"}
              onClick={handleGoToSignIn}
              additionalClasses="xl:text-xxs px-3 py-1 xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
              variant="magnetiqSolid"
            />
          )} */}
        <SignInForm formType={formType} setFormType={setFormType} onLogin={onLoginAfterSubmit} />
        {/* </div> */}
      </div>
    </Modal>
  );
}
export default ClaimMagnetModal;
